import { ActivateTrialStatusDialogs } from './activate-trial-status-dialogs'
import { useActivateTrialRootContext } from './activate-trial-root'

export function ActivateTrialDialogs() {
  const { closeResult, handleSuccessOpenChange, onSettled, result, subscriptionType } =
    useActivateTrialRootContext()

  return (
    <ActivateTrialStatusDialogs
      onErrorClose={() => {
        onSettled?.()
        closeResult()
      }}
      onSuccessOpenChange={handleSuccessOpenChange}
      result={result}
      subscriptionType={subscriptionType}
    />
  )
}
